// COR SELECIONADA — o que varia por cor: fotos proprias e tamanhos (W5,
// plano secao 5 W5 + README "Ficha de produto"). Cabecalho com navegacao
// anterior/proxima entre cores da fila da espinha.
import { ColorSwatch } from "./ColorSwatch";
import { Button } from "../ui/button";
import { ColorPhotosCard, type PhotoManager } from "../PhotosTab";
import { SizeCardsColor, type GridManager } from "../GridTab";

interface ColorPanelProps {
  color: string;
  slug: string;
  disabled: boolean;
  /** RBAC configuravel: capacidade photos.write, independente de products.write. */
  photosDisabled: boolean;
  stock: number;
  onEnabled: boolean;
  prevColor: string | null;
  nextColor: string | null;
  onNavigate: (color: string) => void;
  photoMgr: PhotoManager;
  gridMgr: GridManager;
  selectedForBatch: Set<string>;
  onApplySizesToSelected: (sizes: string[]) => void;
  onDisableColorInChannel: (color: string) => void;
  onCopyPhotosFrom: (fromColor: string) => void;
}

export function ColorPanel({
  color,
  slug,
  disabled,
  photosDisabled,
  stock,
  onEnabled,
  prevColor,
  nextColor,
  onNavigate,
  photoMgr,
  gridMgr,
  selectedForBatch,
  onApplySizesToSelected,
  onDisableColorInChannel,
  onCopyPhotosFrom,
}: ColorPanelProps): JSX.Element {
  return (
    <div className="stack" style={{ gap: ".75rem" }}>
      <div className="card" style={{ borderTop: ".1875rem solid var(--color-coral)" }}>
        <div className="cluster color-panel__header">
          <ColorSwatch name={color} />
          <div className="grow" style={{ minWidth: 0 }}>
            <div style={{ fontSize: "var(--text-2xl)", fontWeight: 900, letterSpacing: "-.02em" }} className="truncate">
              {color}
            </div>
            <div className="card__meta">
              {stock.toLocaleString("pt-BR")} unidades · {onEnabled ? "ligada neste canal" : "desligada neste canal"}
            </div>
          </div>
          <div className="cluster color-panel__nav">
            <Button type="button" variant="secondary" disabled={!prevColor} onClick={() => prevColor && onNavigate(prevColor)}>
              ← {prevColor ?? "—"}
            </Button>
            <Button type="button" variant="secondary" disabled={!nextColor} onClick={() => nextColor && onNavigate(nextColor)}>
              {nextColor ?? "—"} →
            </Button>
          </div>
        </div>
      </div>

      <ColorPhotosCard color={color} slug={slug} disabled={photosDisabled} mgr={photoMgr} onCopyFromColor={onCopyPhotosFrom} />

      <SizeCardsColor
        color={color}
        mgr={gridMgr}
        disabled={disabled}
        canApplyToSelected={selectedForBatch.size > 0}
        onApplyToSelected={onApplySizesToSelected}
        onDisableColor={() => onDisableColorInChannel(color)}
      />
    </div>
  );
}
